export const CART_ADD_RESET = "CART_ADD_RESET";
export const CART_ADD_REQUEST = "CART_ADD_REQUEST";
export const CART_ADD_SUCCESS = "CART_ADD_SUCCESS";
export const CART_ADD_FAIL = "CART_ADD_FAIL";

export const CART_DELETE_RESET = "CART_DELETE_RESET";
export const CART_DELETE_REQUEST = "CART_DELETE_REQUEST";
export const CART_DELETE_SUCCESS = "CART_DELETE_SUCCESS";
export const CART_DELETE_FAIL = "CART_DELETE_FAIL";

export const GET_CART_LIST_RESET = "GET_CART_LIST_RESET";
export const GET_CART_LIST_REQUEST = "GET_CART_LIST_REQUEST";
export const GET_CART_LIST_SUCCESS = "GET_CART_LIST_SUCCESS";
export const GET_CART_LIST_FAIL = "GET_CART_LIST_FAIL";

export const STRIPE_PAYMENT_RESET = "STRIPE_PAYMENT_RESET";
export const STRIPE_PAYMENT_REQUEST = "STRIPE_PAYMENT_REQUEST";
export const STRIPE_PAYMENT_SUCCESS = "STRIPE_PAYMENT_SUCCESS";
export const STRIPE_PAYMENT_FAIL = "STRIPE_PAYMENT_FAIL";

export const PAYPAL_PAYMENT_RESET = "PAYPAL_PAYMENT_RESET";
export const PAYPAL_PAYMENT_REQUEST = "PAYPAL_PAYMENT_REQUEST";
export const PAYPAL_PAYMENT_SUCCESS = "PAYPAL_PAYMENT_SUCCESS";
export const PAYPAL_PAYMENT_FAIL = "PAYPAL_PAYMENT_FAIL";

export const PAYU_PAYMENT_RESET = "PAYU_PAYMENT_RESET";
export const PAYU_PAYMENT_REQUEST = "PAYU_PAYMENT_REQUEST";
export const PAYU_PAYMENT_SUCCESS = "PAYU_PAYMENT_SUCCESS";
export const PAYU_PAYMENT_FAIL = "PAYU_PAYMENT_FAIL";